"use client";

import { useState } from "react";
import React from "react";
import { useMainLayout } from "@/app/context/mainLayoutProvider";
import { GoogleAuthModal } from "@/components/modal/googleAuthModal";
import WaitlistFormModal from "@/components/modal/waitlistFormModal";

interface UseWebViewAuthModalOptions {
  headerText?: string;
}

export const useWebViewAuthModal = (
  options: UseWebViewAuthModalOptions = {}
) => {
  const { headerText = "Create an account" } = options;
  const [googleAuthModalOpen, setGoogleAuthModalOpen] = useState(false);
  const [showWaitlistFormModal, setShowWaitlistFormModal] = useState(false);
  const { isWebView } = useMainLayout();

  const handleClick = () => {
    if (!isWebView) {
      setGoogleAuthModalOpen(true);
    } else {
      setShowWaitlistFormModal(true);
    }
  };

  const AuthModals = () => (
    <>
      <GoogleAuthModal
        headerText={headerText}
        open={googleAuthModalOpen}
        onOpenChange={setGoogleAuthModalOpen}
      />
      <WaitlistFormModal
        open={showWaitlistFormModal}
        onOpenChange={(val) => {
          if (!val) setShowWaitlistFormModal(false);
        }}
      />
    </>
  );

  return {
    handleClick,
    AuthModals,
    isWebView,
  };
};
